import React, { useState } from 'react'
import { useDispatch } from 'react-redux'
import FormFieldLabel from 'src/components/global/ListingForm/FormFieldLabel/FormFieldLabel'
import { PasswordInput } from 'src/components/global/PasswordInput'
import { PrimaryButton } from 'src/components/global/PrimaryButton/PrimaryButton'
import { showToast } from 'src/store/actions/toastAction'
import { validatePasswordPolicy } from 'src/utils/validatePasswordPolicy'

import { SignUpBottom } from './SignUpBottom'

export interface VendorInvitationSignUpFormData {
  first_name: string
  last_name: string | null
  email: string
  // countryId: string
  password: string
  job_title: string
  companyName: string
  companyType: string
  // companySize: string
  // subscribed?: boolean
  // subscribeNewsletterCategories: INewsletterCategoryEntity[]
}

// type company = {
//   companyName?: string
//   companyType?: string
//   companySize?: string
// }

interface Props {
  companyName?: string
  email: string
  first_name: string
  last_name: string | null
  job_title: string
  // company: company
  isProgressing: boolean
  // openTermsConditionsModal: () => void
  onSubmit: (data: VendorInvitationSignUpFormData) => void
}

export const VendorInvitationSignUpForm: React.FC<Props> = ({
  companyName,
  email,
  first_name,
  last_name,
  job_title,
  // company,
  isProgressing,
  // openTermsConditionsModal,
  onSubmit,
}) => {
  const dispatch = useDispatch()
  // const [firstName, setFirstName] = useState('')
  // const [lastName, setLastName] = useState('')
  // const [jobTitle, setJobTitle] = useState('')
  // const [subscribed, setSubscribed] = useState(false)
  // const [subscribeNewsletterCategories, setSubscribeNewsletterCategories] = useState<INewsletterCategoryEntity[]>([])

  // const [countryId, setCountryId] = useState<string | null>(null)

  // const [termsOption, setTermsOption] = useState(false)
  const [password, setPassword] = useState('')
  const [confirmPassword, setConfirmPassword] = useState('')
  const [confirmPasswordError, setConfirmPasswordError] = useState<string | null>(null)
  const [policyMsg, setPolicyMsg] = useState('')

  function isPasswordFieldsValid() {
    if (!confirmPasswordError && !policyMsg && confirmPassword && password && password === confirmPassword) return true
    return false
  }

  const onFormSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault()

    // if (!termsOption) {
    //   dispatch(showToast('Please check Terms of Service.', 'warning'))
    //   return
    // }

    const policy = validatePasswordPolicy(password)
    if (policy !== 'success') {
      dispatch(showToast(policy, 'warning'))
      return
    }

    if (password !== confirmPassword) {
      setConfirmPasswordError('Password mismatch.')
      dispatch(showToast('Password mismatch.', 'warning'))
      return
    }
    // if (!countryId) {
    //   dispatch(showToast('Country required', 'warning'))
    //   return
    // }
    onSubmit({
      first_name,
      last_name,
      email,
      // countryId,
      password,
      job_title,
      companyName: companyName || '',
      // companySize: company.companySize || '',
      companyType: 'Vendor',
      // subscribed,
      // subscribeNewsletterCategories,
    })
  }

  // const onTermsChanged = (checked: boolean) => {
  //   setTermsOption(checked)
  // }
  const onChangePassword = (value: string) => {
    setPassword(value)
    const policy = validatePasswordPolicy(value)
    setPolicyMsg(policy === 'success' ? '' : policy)
  }

  const onChangeConfirmPassword = (value: string) => {
    setConfirmPassword(value)
    setConfirmPasswordError(null)
  }

  const isEnable = !isProgressing

  return (
    <form onSubmit={onFormSubmit} className="w-full" autoComplete="off">
      <div className="flex flex-col w-full">
        {/* <div className="flex flex-row mt-[33px]">
          <div className="w-full text-[0.875rem] font-primary font-regular text-darkgray mr-[1.25rem]">
            <FormFieldLabel label="First Name *" />
            <FormFieldInput
              id="firstName"
              className="text-[15px] font-primary"
              type="text"
              required
              value={firstName}
              onChange={setFirstName}
            />
          </div>
          <div className="w-full text-[0.875rem] font-primary font-regular text-darkgray">
            <FormFieldLabel label="Last Name *" />
            <FormFieldInput
              id="lastName"
              className="text-[15px] font-primary"
              type="text"
              required
              value={lastName}
              onChange={setLastName}
            />
          </div>
        </div> */}

        <div className="flex flex-row mt-[1.375rem]">
          <div className="w-full text-[0.875rem] font-primary font-regular text-darkgray mr-[1.25rem]">
            <FormFieldLabel label="Password *" />
            <PasswordInput
              className="text-[15px] font-primary"
              required
              value={password}
              errorMessage={policyMsg}
              onChange={onChangePassword}
            />
          </div>
        </div>

        <div className="flex flex-row mt-[1.375rem]">
          <div className="w-full text-[0.875rem] font-primary font-regular text-darkgray mr-[1.25rem]">
            <FormFieldLabel label="Confirm Password *" />
            <PasswordInput
              className="text-[15px] font-primary"
              required
              value={confirmPassword}
              errorMessage={confirmPasswordError}
              onChange={onChangeConfirmPassword}
            />
          </div>
        </div>

        {/* <div className="flex flex-row mt-[1.375rem]">
          <div className="w-full">
            <FormFieldLabel label="Job Title *" />
            <FormFieldInput
              id="jobTitle"
              className="text-[15px] font-primary"
              type="text"
              required
              value={jobTitle}
              onChange={setJobTitle}
            />
          </div>
        </div> */}

        {/* <div className="flex flex-col md:flex-row mt-[18px] md:items-center">
          <CheckBox
            labelClassName="i-have-read-and-acce"
            label={'I have read and accepted the'}
            onChanged={onTermsChanged}
            selected={termsOption}
            indeterminate={termsOption}
          />
          <a
            className="i-have-read-and-acce font-bold pt-[3px] ml-[5px] underline cursor-pointer items-center"
            onClick={openTermsConditionsModal}
          >
            Terms of Service
          </a>
        </div> */}

        <div className="flex flex-col gap-3 mt-[27px]">
          <PrimaryButton type="submit" disabled={!(!isEnable || isPasswordFieldsValid())}>
            Submit
          </PrimaryButton>
          <div>
            <SignUpBottom currentStep={2} />
          </div>
        </div>
      </div>
    </form>
  )
}
